import { render, staticRenderFns } from "./ziHuoDongList.vue?vue&type=template&id=a1db2b2c&scoped=true&"
import script from "./ziHuoDongList.vue?vue&type=script&lang=js&"
export * from "./ziHuoDongList.vue?vue&type=script&lang=js&"
import style0 from "./ziHuoDongList.vue?vue&type=style&index=0&id=a1db2b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1db2b2c",
  null
  
)

export default component.exports